import tool from '@/utils/tool';

export function permission(data) {
	let permissions = tool.data.get("MNMALL_PERMISSIONS");
	if(!permissions){
		return false;
	}
	let isHave = permissions.includes(data);
	return isHave;
}

export function rolePermission(data) {
	let userInfo = tool.data.get("MNMALL_USER_INFO");
	if(!userInfo){
		return false;
	}
	let role = userInfo.role;
	if(!role){
		return false;
	}
	let isHave = role.includes(data);
	return isHave;
}

// 基础菜单白名单：登录后人人可见的页面（控制台为默认落地页、帐号信息为个人资料页）
const BASE_MENU_PATHS = ['/home', '/dashboard', '/usercenter'];

/**
 * 按可见菜单路由过滤前端菜单树
 * 规则：叶子节点按 path 精确匹配（白名单 + 授权集合）；
 *       父级目录按"存活的子节点"推导，子节点全部无权限则目录一并隐藏
 * @param {Array} tree 菜单树（routerjson 结构）
 * @param {Array} allowedPaths 登录接口下发的可见页面路由
 * @returns {Array} 过滤后的菜单树
 */
export function filterMenuTree(tree, allowedPaths) {
	const allowed = [...BASE_MENU_PATHS, ...(allowedPaths || [])];
	const walk = (nodes) => nodes
		.map(node => {
			if (node.children && node.children.length) {
				const children = walk(node.children);
				if (!children.length) return null;
				return { ...node, children };
			}
			return allowed.includes(node.path) ? node : null;
		})
		.filter(Boolean);
	return walk(tree);
}
